import Tagify from '@yaireo/tagify';
import { TagifyHTMLInputElement, TagifyTagsHTMLElement } from '../types/tagify';

export function initTagifyField() : void {
    document.querySelectorAll<TagifyHTMLInputElement>('[data-tagify]').forEach($input => {
        const delimiters = $input.getAttribute('data-tagify-delimiters') ?? ',|;| |\n|\r';
        const placeholder = $input.getAttribute('placeholder') ?? null;
        const pattern = $input.getAttribute('data-tagify-pattern') ? new RegExp($input.getAttribute('data-tagify-pattern') as string) : null;
        const userInput = /true|1/.test(($input.getAttribute('data-tagify-user-input') ?? 'true').toLowerCase());
        const whitelist = $input.getAttribute('data-tagify-whitelist') ? JSON.parse($input.getAttribute('data-tagify-whitelist') as string) : null;
        const enforceWhitelist = /true|1/.test(($input.getAttribute('data-tagify-enforce-whitelist') ?? 'false').toLowerCase());

        const options: Record<string, any> = {
            keepInvalidTags: true,
            delimiters,
            placeholder,
            pattern,
            userInput,
            enforceWhitelist,
            editTags: {
                keepInvalid: false,
            },
            texts: {
                empty: 'Vide',
                exceed: 'Nombre d\'éléments maximum atteint',
                pattern: 'Erreur de validation',
                duplicate: 'Doublon',
                notAllowed: 'Non autorisé',
            },
            templates: {
                // Modification du template dropdownFooter contenant 1 texte en anglais écrit en dur.
                dropdownFooter(suggestions: Record<string, any>) {
                    // Traduction du texte anglais
                    const frenchMessage = 'autres résultats. Affinez votre recherche.';

                    // Affichage du code HTML initial en remplaçant le texte anglais par le texte français.
                    const hasMore = suggestions.length - this.settings.dropdown.maxItems;
                    return hasMore > 0
                        ? `<footer data-selector='tagify-suggestions-footer' class="${this.settings.classNames.dropdownFooter}">
                            ${hasMore} ${frenchMessage}
                        </footer>`
                        : '';
                },
            },
        };

        if (whitelist) {
            options.whitelist = whitelist;

            options.keepInvalidTags = false;
            options.dropdown = {
                enabled: 0,
                caseSensitive: true,
                highlightFirst: true,
                closeOnSelect: false,
            };
        }

        const tagify = new Tagify($input, options);

        (tagify.DOM.scope as TagifyTagsHTMLElement).__tagify = $input.__tagify;
    });
}
